app.controller('TitleCtrl', ['$scope', '$location', '$http', 'TraspasoLeadContrato', 'serviciosApi', '$rootScope', '$state', 'jwtHelper', '$mdEditDialog', '$mdDialog', function($scope, $location, $http, TraspasoLeadContrato, serviciosApi, $rootScope, $state, jwtHelper, $mdEditDialog, $mdDialog, $window) {
        
        $scope.NombreTituloPortal = NombreTituloPortal;
}]);